// src/components/TokenForm.tsx
import React from 'react';
import { Button, Form, Alert, Row, Col, Card } from 'react-bootstrap';
import useFetchToken from '../../hooks/useFetchToken';
import { useTranslation } from 'react-i18next';

const TokenForm: React.FC = () => {
  const { t } = useTranslation();
  const { token, error, fetchToken } = useFetchToken();

  const handleFetchToken = () => {
    fetchToken();
  };

  return (
    <Card className="bg-transparent border-0">
      <Row className="mb-4 d-flex justify-content-center">
        <Col md={6}>
          <Form.Group className="mb-0 fs-4 fw-medium text-secondary text-nowrap">
            <Form.Label className="mb-0 fs-4 fw-medium text-secondary">Token</Form.Label>
            <Form.Control type="text" value={token?.uniqueToken || ''} readOnly className='form__field text-secondary fw-medium fs-5 bg-white py-2' />
          </Form.Group>
        </Col>
      </Row>
      {error && <Alert variant="danger" className="mt-2 text-center">{error}</Alert>}
      <Col className="d-flex justify-content-center">
        <Button variant="secondary" onClick={handleFetchToken} className="fs-5 mb-5 py-2 px-3 rounded-3"> {t("userProfile.fetchToken")}</Button>
      </Col>
    </Card>
  );
};

export default TokenForm;
